import type { ObjectSchema } from "yup";
import { boolean, object, string } from "yup";

import type { LoginCredential } from "~/shared/utils/auth-poker-sdk/auth-poker-sdk";

export const createAuthValidationSchema = (t: {
  validation_required: string;
  validation_password_min_width: string;
  validation_password_max_width: string;
}): ObjectSchema<LoginCredential> => {
  return object({
    nick: string().required(t.validation_required),

    password: string()
      .required(t.validation_required)
      .min(5, t?.validation_password_min_width)
      .max(20, t?.validation_password_max_width),
    isRememberPassword: boolean().default(false),
  });
};
